var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var initialState = [
    {
        stepName: 'USER_DETAILS',
        state: 'ACTIVE',
    },
    {
        stepName: 'USER_TYPE',
        state: 'PENDING',
    },
    {
        stepName: 'PAYMENT_PERMISSIONS',
        state: 'HIDDEN',
    },
    {
        stepName: 'REVIEW',
        state: 'PENDING',
    },
];
export var editModeInitialState = [
    {
        stepName: 'USER_DETAILS',
        state: 'COMPLETED',
    },
    {
        stepName: 'USER_TYPE',
        state: 'COMPLETED',
    },
    {
        stepName: 'PAYMENT_PERMISSIONS',
        state: 'HIDDEN',
    },
    {
        stepName: 'REVIEW',
        state: 'PENDING',
    },
];
export var userStepReducer = function (state, action) {
    switch (action.type) {
        case 'DEACTIVATE':
            return state.map(function (step) { return (__assign(__assign({}, step), { state: step.stepName === action.target ? 'PENDING' : step.state })); });
        case 'ACTIVATE':
            return state.map(function (step) {
                return __assign(__assign({}, step), { state: step.stepName === action.target ? 'ACTIVE' : step.state });
            });
        case 'COMPLETE': {
            var nextStepIndex_1 = state.findIndex(function (step) {
                return (step.stepName !== action.target &&
                    // if another step is pending open the first occurence as long as no other step is active
                    // if another step is also active, the user should complete it next
                    (step.state === 'PENDING' || step.state === 'ACTIVE'));
            });
            return state.map(function (step, index) {
                var otherStepStates = index === nextStepIndex_1 ? 'ACTIVE' : step.state;
                return __assign(__assign({}, step), { state: step.stepName === action.target ? 'COMPLETED' : otherStepStates });
            });
        }
        case 'HIDE':
            return state.map(function (step) { return (__assign(__assign({}, step), { state: step.stepName === action.target ? 'HIDDEN' : step.state })); });
        case 'SHOW':
            return state.map(function (step) { return (__assign(__assign({}, step), { state: step.stepName === action.target && step.state === 'HIDDEN'
                    ? 'PENDING'
                    : step.state })); });
        default:
            return state;
    }
};
